import has from 'lodash/has';
import flatten from 'lodash/flatten';
import { parseDomain, ParseResultType } from 'parse-domain';
/* eslint-disable prefer-destructuring */
export const SHARE = process.env.SHARE === 'true' || process.env.APP === 'share';

export const HANDLE_SUBDOMAIN = !SHARE;

export const cookieDomain = () => {
  if (!HANDLE_SUBDOMAIN) {
    return SHARE ? process.env.COOKIE_DOMAIN : window.location.hostname;
  }
  const parseResult = parseDomain(window.location.hostname);
  switch (parseResult.type) {
    case ParseResultType.Listed:
      return [parseResult.domain, ...parseResult.topLevelDomains].join('.');
    case ParseResultType.Reserved:
      // ex: app.insurgate.test → insurgate.test
      return parseResult.labels.slice(-2).join('.');
    default:
      return window.location.hostname;
  }
};

export const ROOT_DOMAIN = SHARE ? window.location.hostname : HANDLE_SUBDOMAIN ? cookieDomain() : process.env.ROOT_DOMAIN;
export const APP_DOMAIN = SHARE ? window.location.hostname : HANDLE_SUBDOMAIN ? `app.${cookieDomain()}` : process.env.APP_DOMAIN;
export const PROTOCOL = process.env.PROTOCOL;
export const API_DOMAIN = process.env.API_DOMAIN;
export const CABLE_DOMAIN = process.env.CABLE_DOMAIN;
export const CABLE_PATH = process.env.CABLE_PATH;
export const CABLE_PROTOCOL = process.env.CABLE_PROTOCOL;
export const PAUL_DOMAIN = process.env.PAUL_DOMAIN;
export const ENVIRONMENT = process.env.APP_ENV;
export const DEVELOPMENT = process.env.APP_ENV === 'development';
export const STAGING = process.env.APP_ENV === 'staging';
export const VALIDATION = process.env.APP_ENV === 'validation';
export const PRODUCTION = process.env.APP_ENV === 'production';
export const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;
export const DEFAULT_LOCALE = 'nl';
export const AVAILABLE_LOCALES = ['fr', 'nl'];
export const DEFAULT_CONTACT_EMAIL = 'support@insurgate.com';
export const INTEGRATION_INVITATION_COOKIE = 'integration_invitation_token';
export const MAINTENANCE_MODE = process.env.MAINTENANCE_MODE === 'ON';
export const ACTIVE_GROUP_COOKIE_NAME = 'active_group_id';
export const BYPASS_MAINTENANCE_COOKIE_NAME = 'bypass_maintenance';
export const DATA_BE_API = process.env.DATA_BE_API;
export const BCE_PUBLIC_URL = process.env.BCE_PUBLIC_URL;
export const BCE_PUBLIC_TOKEN = process.env.BCE_PUBLIC_TOKEN;
export const LANSKY_BASIC_AUTH_USER = 'insurgate';
export const LANSKY_BASIC_AUTH_PASSWORD = 'insurgate';
export const BUILD_ID = process.env.BUILD_ID;
export const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY;
export const RECAPTCHA_SITE_KEY_V3 = process.env.RECAPTCHA_SITE_KEY_V3;
export const COOKIES_EXPIRES_IN_DAYS = 60;
export const CARAPI_DOMAIN = process.env.CARAPI_DOMAIN;
export const EUROTAX_DOMAIN = process.env.EUROTAX_DOMAIN;
export const SOCKET_PROTOCOL = process.env.SOCKET_PROTOCOL;
export const MAX_VISIBLE_STEPS = 15;
export const PREVIEW_DEPLOY = process.env.PREVIEW_DEPLOY === 'true';
export const N8N_DOMAIN = process.env.N8N_DOMAIN;
export const ARCHIBALD_DOMAIN = DEVELOPMENT ? 'https://archibald.insurgate.test' : process.env.ARCHIBALD_DOMAIN;
export const N8N_PROXY = process.env.N8N_PROXY;
export const EUROTAX_YUZZU_DOMAIN = process.env.EUROTAX_YUZZU_DOMAIN;
export const EUROTAX_YUZZU_TCAR8_DOMAIN = process.env.EUROTAX_YUZZU_TCAR8_DOMAIN;
export const BELGIAN_DOMAIN =
  window.location.host.endsWith('.be') ||
  window.location.host.endsWith('.com') ||
  window.location.host.endsWith('.test') ||
  window.location.host.endsWith('.me');
export const ENVIRONMENT_BANNER = process.env.ENVIRONMENT_BANNER;
export const ALGOLIA_APPLICATION_ID = process.env.ALGOLIA_APPLICATION_ID;
export const ALGOLIA_API_KEY = process.env.ALGOLIA_API_KEY;
export const IG_NOTIFICATION_URL = process.env.IG_NOTIFICATION_URL;
export const GENIE_DOMAIN = process.env.GENIE_DOMAIN;
export const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID;
export const OPENPANEL_CLIENT_ID = process.env.OPENPANEL_CLIENT_ID;
export const OPENPANEL_API_URL = process.env.OPENPANEL_API_URL;
export const PAPPERS_API_KEY = process.env.PAPPERS_API_KEY;
export const UNLAYER_PROJECT_ID = process.env.UNLAYER_PROJECT_ID;
export const YUZZU_CONTRACT_SEARCH_ENDPOINT = process.env.YUZZU_CONTRACT_SEARCH_ENDPOINT;
export const DEFAULT_REFERENCE_DATA_SELECTOR_KEY = 'ref_data_selector';
export const IG_SLS_ENDPOINT = process.env.IG_SLS_ENDPOINT;

export const slugify = (string) => {
  if (!string) {
    return null;
  }
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/,:;';
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '_') // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/\-\-+/g, '_') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};

export const hasIntegrationConfigurationTemplate = (product) => {
  return has(product, 'integration_configuration_template.schema') && Object.keys(product.integration_configuration_template.schema).length > 0;
};

export const hasAdminIntegrationConfigurationTemplate = (product) => {
  return has(product, 'integration_admin_configuration_template.schema') && Object.keys(product.integration_admin_configuration_template.schema).length > 0;
};

export const hasMetadata = (product) => {
  return has(product, 'metadata') && Object.keys(product.metadata || {}).length > 0;
};

export const getAvailableLocalesListOption = (t) => {
  return AVAILABLE_LOCALES.map((availableLocale) => ({
    value: availableLocale,
    label: t(`global.locales.${availableLocale}`),
  }));
};

export const OPERATION_KINDS_ORDERED = [
  'validate_steps',
  'duplicate_request',
  'brain',
  'recompute_all',
  'api',
  'generate_documents',
  'send_email',
  'delete_documents',
  'change_status',
  'revert_status',
  'set_seller_as_editor',
  'next_step',
  'redirect_to',
  'open_url',
];

export const sortOperations = (operations) => {
  const orderedOperations = [];
  OPERATION_KINDS_ORDERED.map((kind) => {
    orderedOperations.push(operations.filter((operation) => operation.kind === kind));
  });
  return flatten(orderedOperations);
};

export const VIEW_STATUSES = [
  {
    value: 'draft',
    label: 'Draft',
  },
  {
    value: 'live',
    label: 'Live',
  },
  {
    value: 'disabled',
    label: 'Disabled',
  },
];

export const VIEW_KINDS = [
  {
    value: 'form',
    label: 'Form',
  },
  {
    value: 'api',
    label: 'API',
  },
];

export const VIEW_USER_KINDS = [
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: 'customer',
    label: 'Customer',
  },
  {
    value: 'seller',
    label: 'Seller',
  },
  { value: 'agent', label: 'Agent' },
];

export const DOCUMENT_TEMPLATES_FILE_TYPES = [
  {
    value: 'pdf',
    label: 'PDF',
  },
  {
    value: 'docx',
    label: 'DOCX',
  },
];

export const getFilenameWithoutExtension = (filename) => {
  return filename?.split('.').slice(0, -1).join('.');
};

export const truncateComment = (comment, length = 20) => {
  if (comment.length > length) {
    return `${comment.substring(0, length)}...`;
  }
  return comment;
};

export const getBrandLink = (brand) => {
  return brand.link || `${PROTOCOL}://${brand.slug}.${ROOT_DOMAIN}`;
};

/* eslint-enable */
